// hooks/useUnapprovedDJTCount.js
import { useState, useEffect, useCallback } from 'react';
import { fetchDJTsByStatusId } from '../graphqlCompnents/DJT/fetchDJTsByStatusId.jsx';
import { getStatusIdByStatusCode } from '../graphqlCompnents/DJT/getStatusIdByStatusCode.jsx';

export const useUnapprovedDJTCount = (refreshInterval = 15 * 60 * 1000) => {
  const [count, setCount] = useState(0);

  const fetchCount = useCallback(async () => {
    try {
      const unapprovedStatusId = await getStatusIdByStatusCode('queued-pending-approval');
      const data = await fetchDJTsByStatusId(unapprovedStatusId);
      setCount(Array.isArray(data) ? data.length : 0);
    } catch (err) {
      console.error('Error fetching unapproved DJT count:', err);
    }
  }, []);

  useEffect(() => {
    fetchCount();
    const interval = setInterval(fetchCount, refreshInterval);
    return () => clearInterval(interval);
  }, [fetchCount, refreshInterval]);

  return count;
};